const RegexPattern = {
    Html: /(<[a-zA-Z\!\/\?]|&#)/,
    Number: /^\d+$/,
    PhoneNumber: '^(?!.*([0-9])\\1{9})[0-9]{10}$',
    Email: /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i,
};

export enum EValidationType {
    required,
    email,
}
export type TFormFieldItems = {
    [keyof: string]: {
        value: string;
        validationType: EValidationType;
    };
};

export type TValidatedItems = {
    [key: string]: boolean;
};

export type TValidatedForm = {
    validatedItems: { [keyof: string]: boolean };
    isValid: boolean;
};

export const validateRequiredField = (value: string = '', minLength: number = 1): boolean => {
    return value.length >= minLength;
};

export const validateEmail = (email: string = ''): boolean => {
    return RegexPattern.Email.test(email);
};

export const validateForm = (formItems: TFormFieldItems): TValidatedForm => {
    const validatedItems: TValidatedItems = {};
    let valid: boolean;
    for (const [key, item] of Object.entries(formItems)) {
        switch (item.validationType) {
            case EValidationType.email:
                valid = validateEmail(item.value);
                validatedItems[key] = valid;
                break;
            case EValidationType.required:
                valid = validateRequiredField(item.value);
                validatedItems[key] = valid;
                break;
            default:
                break;
        }
    }
    return {
        validatedItems,
        isValid: Object.values(validatedItems).every((item) => item === true),
    };
};
